import { WS_URL, API_URL } from '../env';

/* Functions for fetching data from the api. In the future should be refactored to use reactQuery or similar, also including authentication.
Also includes creating websocket connections for data and vs. */
async function fetchData(url, method, body) {
    const headers = {
        "Content-Type": "application/json"
    }
    let response;
    if (method === "GET") {
        response = await fetch(url, {
            method,
            headers
        });
    } else {
        response = await fetch(url, {
            method,
            headers,
            body: JSON.stringify(body)
        });
    }
    if (!response.ok) throw new Error("Network response was not ok");
    const resData = await response.json();
    return JSON.parse(resData);
}

export const createWebsocketConnection = () => {
    const WEBSOCKET_URL = `${WS_URL}/forex`;
    return new WebSocket(WEBSOCKET_URL);
}

